import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
    selector: "input[type=number]",
    standalone: false
})
export class DisableNumberInputScroll {
  constructor(private eleRef: ElementRef) {}

  @HostListener("wheel", ["$event"])
  @HostListener("scroll", ["$event"])
  onWheel(event: Event) {
    if (this.eleRef.nativeElement === event.target) {
      event.preventDefault();
    }
  }

  @HostListener("document:keydown", ["$event"])
  onKeydown(event: any) {
    if (this.eleRef.nativeElement === event.target) {
      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        event.preventDefault();
      }
    }
  }
}
